import type { ReactNode } from 'react'
import { DialogOverlay, VerlaufDialog, VerlaufMedia } from '..'

type VerlaufTheme = 'dark' | 'light'

interface VerlaufMediaConfig {
  storageId: number
  /** Play as direct MP4 video */
  video?: boolean
  /** HLS stream URL for adaptive streaming */
  hlsUrl?: string
}

interface VerlaufModalDialogProps {
  open: boolean
  onClose: () => void
  theme?: VerlaufTheme
  media: VerlaufMediaConfig
  children: ReactNode
}

/**
 * Generic modal Verlauf dialog — split layout with media slot.
 *
 * Provides the full modal infrastructure (overlay, escape, scroll-lock)
 * plus the Verlauf layout (content left, video/image right).
 * Pass any content as children.
 *
 * Usage:
 *   <VerlaufModalDialog open={show} onClose={close} media={{ storageId: 101705, video: true }}>
 *     <h3 className="sg-dialog__title">Titel</h3>
 *     <p className="sg-vdialog__desc">Beschreibung</p>
 *     ...
 *   </VerlaufModalDialog>
 */
export default function VerlaufModalDialog({ open, onClose, theme = 'light', media, children }: VerlaufModalDialogProps) {
  return (
    <DialogOverlay open={open} onClose={onClose}>
      <VerlaufDialog
        theme={theme}
        onClose={onClose}
        videoSlot={
          <VerlaufMedia
            storageId={media.storageId}
            video={media.video}
            hlsUrl={media.hlsUrl}
          />
        }
      >
        {children}
      </VerlaufDialog>
    </DialogOverlay>
  )
}
